(() => {

    function setVH(){
        if (document.body.classList.contains('user-is-touching')) {
           return;
        }

        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    // initial
    document.addEventListener("DOMContentLoaded", setVH);

    // We listen to the resize event
    window.addEventListener('resize', setVH);

    // touchstart
    window.addEventListener('touchstart', function onFirstTouch() {
        // we could use a class
        document.body.classList.add('user-is-touching');

        // we only need to know once that a human touched the screen, so we can stop listening now
        window.removeEventListener('touchstart', onFirstTouch, false);
        window.removeEventListener('resize', setVH, false);

    }, false);


})();


